import { useState } from "react";
import BillWrap from "./BillWrap";
import {Tab} from "omoplay";
import CardBillingForm from "../form/CardBillingForm";
import {useRecoilValue} from "recoil";
import {accountSelector, channelSelector} from "../../store/selector/selector";
import {channelPermissions, hasAdminGrant} from "../../libs/permissions";

// '세금 계산서' 탭은 2026-08-03 제거했다.
//  - 그 탭이 보여주던 값은 실제 발행되는 전자세금계산서와 **연동되어 있지 않았고**,
//  - 발행 대상이 아닌 업체에도 무조건 노출돼 오해를 샀다.
// → 세금계산서 발행 대상 업체에만 '월 별 내역서' 안에서 '세금계산서 확인하기' 버튼으로 팝업 제공한다.
//   구 컴포넌트 `TaxInvoice.js` 는 더 이상 라우팅되지 않는다(파일은 남아 있음).


const Payments = () => {
    const channel = useRecoilValue(channelSelector)
    const account = useRecoilValue(accountSelector)
    // 판정은 `libs/permissions.js` 한 곳에서 한다 — 종전 `permissions?.[0]?.grant` 는
    // 서버 조회에 `ORDER BY` 가 없어 **어느 권한 행이 [0] 인지가 DB 순서에 달려** 있었다.
    const permissions = channelPermissions(account, channel)
    const isAdmin = hasAdminGrant(permissions)


    const tabs = [
        { value: "regular", label: "결제 정보", selected: true },
    ];

    if (isAdmin) {
        tabs.push(
            { value: "bill", label: "월 별 내역서" },
        )
    }

    const [activeTab, setActiveTab] = useState(tabs[0].value);

    return (
        <div className="flex-col gap-4">
            <Tab items={tabs} onChanged={(tab) => setActiveTab(tab.value)}
                 style={{gap: "4px"}} />
            {activeTab === "regular" && <CardBillingForm />}
            {activeTab === "bill" && <BillWrap />}
        </div>
    );
};

export default Payments;
